import styled from "styled-components";

export const DatePickerContainer = styled.div`
    width: 100%;
`;
export const DateRangePickerContainer = styled.div`
    position: absolute;
    z-index: 999;
`;